import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { ArrowUpRight } from "lucide-react";

export default function BlogListPage() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data || [])).finally(() => setLoading(false));
  }, []);

  return (
    <div className="pt-32 pb-28 min-h-screen" data-testid="blog-list-page">
      <div className="max-w-4xl mx-auto px-6 sm:px-10">
        <p className="overline text-volt">[ WRITING LOG ]</p>
        <h1 className="font-display font-black text-5xl sm:text-7xl tracking-tighter mt-4">Blog.</h1>
        <p className="text-fog-300 mt-4 max-w-2xl">
          Thoughts on agentic AI, MLOps in production, fintech, and the frontier where money meets machine intelligence.
        </p>
        <div className="mt-14 divide-y divide-white/10 border-y border-white/10">
          {loading && <p className="text-fog-300 py-8">Loading…</p>}
          {!loading && posts.length === 0 && <p className="text-fog-300 py-8">No posts yet.</p>}
          {posts.map((p) => (
            <Link
              key={p.id}
              to={`/blog/${p.slug}`}
              className="group flex items-start justify-between gap-6 py-8 hover:bg-white/[0.015] transition px-2"
              data-testid={`blog-list-item-${p.slug}`}
            >
              <div>
                <div className="flex items-center gap-2 mb-2">
                  {p.subsubsection && <span className="tag-chip">{p.subsubsection}</span>}
                  <span className="overline text-volt">{p.ai_assisted ? "AI-ASSISTED" : "HUMAN-WRITTEN"}</span>
                </div>
                <h3 className="font-display font-bold text-2xl sm:text-3xl tracking-tight group-hover:text-volt">
                  {p.title}
                </h3>
                {p.excerpt && <p className="mt-2 text-fog-300">{p.excerpt}</p>}
              </div>
              <ArrowUpRight className="w-6 h-6 text-fog-300 group-hover:text-volt shrink-0 mt-2" />
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
